import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../../public/assets/img/pdf/transnetBW/tng-logo.png'


const _withScopeId = n => (_pushScopeId("data-v-3b01d805"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "landingpage-background w-screen h-screen" }
const _hoisted_2 = {
  class: "flex flex-col justify-between",
  style: {"height":"1020px"}
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex justify-between" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-3xl md:text-3xl" }, "Seilzug Checkliste"),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      width: "200"
    })
  ])
], -1))
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "h-full max-h-full" }
const _hoisted_6 = { class: "mt-2 grid grid-cols-8 justify-items-stretch items-center" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-span-3 text- font-bold",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, " Vorhaben ", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-sm font-bold col-span-3",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, " Aufnahmedaten ", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-span-2 text-sm font-bold",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, " Mast-Foto ", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs ml-2" }, "Vorhaben:", -1))
const _hoisted_11 = { class: "text-gray-500 col-span-2 text-xs" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs ml-2" }, "Bearbeiterin:", -1))
const _hoisted_13 = {
  key: 0,
  class: "text-gray-500 text-xs col-span-2"
}
const _hoisted_14 = {
  key: 1,
  class: "col-span-2"
}
const _hoisted_15 = {
  key: 2,
  class: "mt-2 row-span-5 col-span-2"
}
const _hoisted_16 = ["src"]
const _hoisted_17 = {
  key: 3,
  class: "row-span-5 col-span-2 flex item-stretch justify-center items-center mt-2",
  style: {"height":"150px","max-height":"150px","background-color":"rgb(235, 239, 240)","border-radius":"5px","border-style":"solid","border-color":"rgb(235, 239, 240) rgb(235, 239, 240)\n                    rgb(235, 239, 240) rgb(235, 239, 240)"}
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-center self-center" }, " Kein Bild hinzugefügt ", -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs ml-2" }, "Anlagennummer:", -1))
const _hoisted_21 = { class: "text-gray-500 text-xs col-span-2" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs ml-2" }, "Firma:", -1))
const _hoisted_23 = { class: "text-gray-500 col-span-2 text-xs" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs ml-2" }, "Mastnummer:", -1))
const _hoisted_25 = { class: "text-gray-500 text-xs col-span-2" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2 ml-2" }, "Begehungsdatum:", -1))
const _hoisted_27 = { class: "text-gray-500 text-xs" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-span-3" }, null, -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2 ml-2" }, "Bearbeitungsstatus:", -1))
const _hoisted_30 = { class: "text-gray-500 text-xs" }
const _hoisted_31 = {
  key: 0,
  class: "text-gray-500"
}
const _hoisted_32 = {
  key: 1,
  class: "text-gray-500"
}
const _hoisted_33 = {
  key: 2,
  class: "text-gray-500"
}
const _hoisted_34 = {
  key: 3,
  class: "text-gray-500"
}
const _hoisted_35 = {
  key: 4,
  class: "text-gray-500"
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-span-3" }, null, -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2 ml-2" }, "Aktualisierungsdatum:", -1))
const _hoisted_38 = { class: "text-gray-500 text-xs" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs" }, "Unterzeichnet von:", -1))
const _hoisted_40 = { class: "col-span-2" }
const _hoisted_41 = {
  key: 4,
  class: "h-2 text-xs ml-2 col-span-5"
}
const _hoisted_42 = ["src"]
const _hoisted_43 = {
  key: 5,
  class: "h-2 text-xs ml-2 col-span-3 flex item-stretch justify-center items-center",
  style: {"height":"50px","max-height":"50px","background-color":"rgb(235, 239, 240)","border-radius":"5px","border-style":"solid","border-color":"rgb(235, 239, 240) rgb(235, 239, 240)\n                    rgb(235, 239, 240) rgb(235, 239, 240)"}
}
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-center self-center" }, " keine Unterschrift hinzugefügt ", -1))
const _hoisted_45 = [
  _hoisted_44
]
const _hoisted_46 = {
  class: "mt-6 flex justify-between",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xl md:text-xl font-bold" }, "Gesamt-Bewertung", -1))
const _hoisted_48 = { class: "mt-2 ml-2 text-xs" }
const _hoisted_49 = { class: "text-xs text-gray-500" }
const _hoisted_50 = {
  class: "mt-6 flex justify-between",
  style: {"border-style":"solid","border-color":"white white rgb(216, 215, 26) white","border-radius":"5px"}
}
const _hoisted_51 = { class: "text-lg md:text-lg" }
const _hoisted_52 = { class: "text-xs" }
const _hoisted_53 = { class: "text-xs" }
const _hoisted_54 = { class: "justify-self-end" }
const _hoisted_55 = { class: "p-2 grid grid-cols-8 gap-1 justify-item-stretch" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-span-4 text-sm ml-1" }, "Seilzugfläche:", -1))
const _hoisted_57 = { class: "justify-self-end" }
const _hoisted_58 = { class: "justify-self-end" }
const _hoisted_59 = { class: "justify-self-end" }
const _hoisted_60 = { class: "justify-self-end" }
const _hoisted_61 = {
  key: 0,
  class: "col-span-4 text-sm ml-1"
}
const _hoisted_62 = {
  key: 1,
  style: {"display":"contents"}
}
const _hoisted_63 = { class: "justify-self-end" }
const _hoisted_64 = { class: "justify-self-end" }
const _hoisted_65 = { class: "justify-self-end" }
const _hoisted_66 = { class: "justify-self-end" }
const _hoisted_67 = {
  key: 2,
  class: "col-span-8 text-sm ml-1"
}
const _hoisted_68 = {
  key: 3,
  class: "col-span-4 text-sm ml-1"
}
const _hoisted_69 = {
  key: 4,
  style: {"display":"contents"}
}
const _hoisted_70 = { class: "justify-self-end" }
const _hoisted_71 = { class: "justify-self-end" }
const _hoisted_72 = { class: "justify-self-end" }
const _hoisted_73 = { class: "justify-self-end" }
const _hoisted_74 = {
  key: 5,
  class: "col-span-8 text-sm ml-1"
}
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_76 = {
  class: "flex justify-between",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-lg md:text-lg" }, "Fremdleitungen", -1))
const _hoisted_78 = { class: "p-2 grid grid-cols-8 gap-2 w-fit" }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-span-4 ml-2 text-sm" }, "Fremdleitungen:", -1))
const _hoisted_80 = { class: "justify-self-end" }
const _hoisted_81 = { class: "justify-self-end" }
const _hoisted_82 = { class: "justify-self-end" }
const _hoisted_83 = { class: "justify-self-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageCounter = _resolveComponent("PageCounter")!
  const _component_PdfChip = _resolveComponent("PdfChip")!
  const _component_seilzugflaechen_footer = _resolveComponent("seilzugflaechen-footer")!
  const _component_pdf_a4_page = _resolveComponent("pdf-a4-page")!

  return (_openBlock(), _createBlock(_component_pdf_a4_page, {
    "no-margin": "",
    "pdf-key": _ctx.lang,
    class: "pdf-content"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_PageCounter),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _hoisted_8,
                _hoisted_9,
                _hoisted_10,
                _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.useIdentifierFrageFinder(
                    _ctx.ba,
                    'rippistein-seilzugflaechen.allgemein-tab.allgemein-group.vorhaben'
                  )['eingabeText']), 1),
                _hoisted_12,
                (_ctx.ba?.bearbeitenderNutzer)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.ba?.bearbeitenderNutzer?.username), 1))
                  : (_openBlock(), _createElementBlock("div", _hoisted_14)),
                (_ctx.getPhotoUrl(_ctx.immobilie?.vorschaubild))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createElementVNode("img", {
                        src: _ctx.getPhotoUrl(_ctx.immobilie?.vorschaubild),
                        style: {"max-height":"150px"},
                        height: "150",
                        width: "180",
                        "data-cy": "generalData-vorschaubild"
                      }, null, 8, _hoisted_16)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_19)),
                _hoisted_20,
                _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.useIdentifierFrageFinder(
                    _ctx.ba,
                    'rippistein-seilzugflaechen.allgemein-tab.allgemein-group.anlage'
                  )['eingabeText']), 1),
                _hoisted_22,
                _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.useIdentifierFrageFinder(
                    _ctx.ba,
                    'rippistein-seilzugflaechen.allgemein-tab.allgemein-group.firma'
                  )['eingabeText']), 1),
                _hoisted_24,
                _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.useIdentifierFrageFinder(
                    _ctx.ba,
                    'rippistein-seilzugflaechen.allgemein-tab.allgemein-group.mastnummer'
                  )['eingabeText']), 1),
                _hoisted_26,
                _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.moment(_ctx.ba?.begehungsdatum).format('DD-MM-YYYY')), 1),
                _hoisted_28,
                _hoisted_29,
                _createElementVNode("div", _hoisted_30, [
                  (_ctx.ba?.status === 'ANGELEGT')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_31, " angelegt "))
                    : (_ctx.ba?.status === 'IN_DURCHFUEHRUNG')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_32, " in Durchführung "))
                      : (_ctx.ba?.status === 'ABGESCHLOSSEN')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_33, " abgeschlossen "))
                        : (_ctx.ba?.status === 'FREIGEGEBEN')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_34, " freigegeben "))
                          : (_ctx.ba?.status === 'ARCHIVIERT')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_35, " archiviert "))
                            : _createCommentVNode("", true)
                ]),
                _hoisted_36,
                _hoisted_37,
                _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.moment(_ctx.ba?.updatedAt).format('DD-MM-YYYY')), 1),
                _hoisted_39,
                _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.ba?.unterschrifts[0]?.name || ''), 1),
                (_ctx.getPhotoUrl(_ctx.ba?.unterschrifts[0]?.bild) != undefined)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                      _createElementVNode("img", {
                        src: _ctx.getPhotoUrl(_ctx.ba?.unterschrifts[0]?.bild),
                        style: {"max-height":"50px","max-width":"180px","background":"#efefef"},
                        height: "50",
                        width: "180"
                      }, null, 8, _hoisted_42)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_43, _hoisted_45))
              ]),
              _createElementVNode("div", _hoisted_46, [
                _hoisted_47,
                _createElementVNode("div", null, [
                  _createVNode(_component_PdfChip, {
                    color: _ctx.summarizeOverallSeilzugflaechen(_ctx.ba)['color'],
                    "mangel-amount-mode": "",
                    value: _ctx.summarizeOverallSeilzugflaechen(_ctx.ba)['amount'],
                    "pdf-mode": ""
                  }, null, 8, ["color", "value"])
                ])
              ]),
              _createElementVNode("div", _hoisted_48, [
                _createTextVNode(" Bewertung der Bearbeiterin: "),
                _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.ba?.fazit), 1)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getSeilzugflaechen(_ctx.ba), (seilzugflaeche, szfKey) => {
                return (_openBlock(), _createElementBlock("div", { key: szfKey }, [
                  _createElementVNode("div", _hoisted_50, [
                    _createElementVNode("div", _hoisted_51, "Seilzugfläche " + _toDisplayString(szfKey + 1), 1),
                    _createElementVNode("div", _hoisted_52, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba,'ergebnis-modal.ergebnis.seilzugflaeche')?.getSelectedAuswahlLabelsString()), 1),
                    _createElementVNode("div", _hoisted_53, "Zuwegung: " + _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba,'ergebnis-modal.ergebnis.ergebniszuwegung')?.getSelectedAuswahlLabelsString()), 1),
                    _createElementVNode("div", _hoisted_54, [
                      _createVNode(_component_PdfChip, {
                        color: _ctx.summarizeSeilzugflaecheBewertungen(_ctx.ba,seilzugflaeche)['color'],
                        "mangel-amount-mode": "",
                        value: _ctx.summarizeSeilzugflaecheBewertungen(_ctx.ba,seilzugflaeche)['amount'],
                        "pdf-mode": ""
                      }, null, 8, ["color", "value"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_55, [
                    _hoisted_56,
                    _createElementVNode("div", _hoisted_57, [
                      _createVNode(_component_PdfChip, {
                        color: "green",
                        "mangel-amount-mode": "",
                        value: 
                    Object?.values(_ctx.getSeilzugflaecheBewertungen(_ctx.ba,seilzugflaeche)['seilzugflaeche'])
                      ?.flat(1)
                      ?.filter((f) => {
                        return f === 'plus';
                      })?.length
                  ,
                        "pdf-mode": ""
                      }, null, 8, ["value"])
                    ]),
                    _createElementVNode("div", _hoisted_58, [
                      _createVNode(_component_PdfChip, {
                        color: "blue",
                        "mangel-amount-mode": "",
                        value: 
                    Object?.values(_ctx.getSeilzugflaecheBewertungen(_ctx.ba,seilzugflaeche)['seilzugflaeche'])
                      ?.flat(1)
                      ?.filter((f) => {
                        return f === 'o';
                      })?.length
                  ,
                        "pdf-mode": ""
                      }, null, 8, ["value"])
                    ]),
                    _createElementVNode("div", _hoisted_59, [
                      _createVNode(_component_PdfChip, {
                        color: "yellow",
                        "mangel-amount-mode": "",
                        value: 
                    Object?.values(_ctx.getSeilzugflaecheBewertungen(_ctx.ba,seilzugflaeche)['seilzugflaeche'])
                      ?.flat(1)
                      ?.filter((f) => {
                        return f === 'minus';
                      })?.length
                  ,
                        "pdf-mode": ""
                      }, null, 8, ["value"])
                    ]),
                    _createElementVNode("div", _hoisted_60, [
                      _createVNode(_component_PdfChip, {
                        color: "red",
                        "mangel-amount-mode": "",
                        value: 
                    Object?.values(_ctx.getSeilzugflaecheBewertungen(_ctx.ba,seilzugflaeche)['seilzugflaeche'])
                      ?.flat(1)
                      ?.filter((f) => {
                        return f === 'x';
                      })?.length
                  ,
                        "pdf-mode": ""
                      }, null, 8, ["value"])
                    ]),
                    (seilzugflaeche.findFrageByRelativePath(_ctx.ba, 'allgemein-modal.allgemein-group.zuwegung-vorhanden')?.getCurrentInput() ||
              seilzugflaeche.findFrageByRelativePath(_ctx.ba, 'allgemein-modal.allgemein-group.zuwegung-notwendig')?.getCurrentInput() )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_61, "Zuwegung Seilzugfläche:"))
                      : _createCommentVNode("", true),
                    (seilzugflaeche.findFrageByRelativePath(_ctx.ba, 'allgemein-modal.allgemein-group.zuwegung-vorhanden')?.getCurrentInput() ||
              seilzugflaeche.findFrageByRelativePath(_ctx.ba, 'allgemein-modal.allgemein-group.zuwegung-notwendig')?.getCurrentInput() )
                      ? (_openBlock(), _createElementBlock("span", _hoisted_62, [
                          _createElementVNode("div", _hoisted_63, [
                            _createVNode(_component_PdfChip, {
                              color: "green",
                              "mangel-amount-mode": "",
                              value: 
                    Object?.values(_ctx.getSeilzugflaecheBewertungen(_ctx.ba,seilzugflaeche)['zuwegungSeilzugflaeche'])
                      ?.flat(1)
                      ?.filter((f) => {
                        return f === 'plus';
                      })?.length
                  ,
                              "pdf-mode": ""
                            }, null, 8, ["value"])
                          ]),
                          _createElementVNode("div", _hoisted_64, [
                            _createVNode(_component_PdfChip, {
                              color: "blue",
                              "mangel-amount-mode": "",
                              value: 
                    Object?.values(_ctx.getSeilzugflaecheBewertungen(_ctx.ba,seilzugflaeche)['zuwegungSeilzugflaeche'])
                      ?.flat(1)
                      ?.filter((f) => {
                        return f === 'o';
                      })?.length
                  ,
                              "pdf-mode": ""
                            }, null, 8, ["value"])
                          ]),
                          _createElementVNode("div", _hoisted_65, [
                            _createVNode(_component_PdfChip, {
                              color: "yellow",
                              "mangel-amount-mode": "",
                              value: 
                    Object?.values(_ctx.getSeilzugflaecheBewertungen(_ctx.ba,seilzugflaeche)['zuwegungSeilzugflaeche'])
                      ?.flat(1)
                      ?.filter((f) => {
                        return f === 'minus';
                      })?.length
                  ,
                              "pdf-mode": ""
                            }, null, 8, ["value"])
                          ]),
                          _createElementVNode("div", _hoisted_66, [
                            _createVNode(_component_PdfChip, {
                              color: "red",
                              "mangel-amount-mode": "",
                              value: 
                    Object?.values(_ctx.getSeilzugflaecheBewertungen(_ctx.ba,seilzugflaeche)['zuwegungSeilzugflaeche'])
                      ?.flat(1)
                      ?.filter((f) => {
                        return f === 'x';
                      })?.length
                  ,
                              "pdf-mode": ""
                            }, null, 8, ["value"])
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_67, "Zuwegung zu Seilzugfläche nicht vorhanden und nicht benötigt")),
                    (seilzugflaeche.findFrageByRelativePath(_ctx.ba, 'allgemein-modal.allgemein-group.flaeche-vorhanden')?.getCurrentInput() ||
              seilzugflaeche.findFrageByRelativePath(_ctx.ba, 'allgemein-modal.allgemein-group.flaeche-notwendig')?.getCurrentInput() )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_68, "Fläche zwischen Mast und Seilzugfläche:"))
                      : _createCommentVNode("", true),
                    (seilzugflaeche.findFrageByRelativePath(_ctx.ba, 'allgemein-modal.allgemein-group.flaeche-vorhanden')?.getCurrentInput() ||
              seilzugflaeche.findFrageByRelativePath(_ctx.ba, 'allgemein-modal.allgemein-group.flaeche-notwendig')?.getCurrentInput() )
                      ? (_openBlock(), _createElementBlock("span", _hoisted_69, [
                          _createElementVNode("div", _hoisted_70, [
                            _createVNode(_component_PdfChip, {
                              color: "green",
                              "mangel-amount-mode": "",
                              value: 
                    Object?.values(_ctx.getSeilzugflaecheBewertungen(_ctx.ba,seilzugflaeche)?.['flaecheZwischenMastUndSeilzug'])
                      ?.flat(1)
                      ?.filter((f) => {
                        return f === 'plus';
                      })?.length
                  ,
                              "pdf-mode": ""
                            }, null, 8, ["value"])
                          ]),
                          _createElementVNode("div", _hoisted_71, [
                            _createVNode(_component_PdfChip, {
                              color: "blue",
                              "mangel-amount-mode": "",
                              value: 
                    Object?.values(_ctx.getSeilzugflaecheBewertungen(_ctx.ba,seilzugflaeche)?.['flaecheZwischenMastUndSeilzug'])
                      ?.flat(1)
                      ?.filter((f) => {
                        return f === 'o';
                      })?.length
                  ,
                              "pdf-mode": ""
                            }, null, 8, ["value"])
                          ]),
                          _createElementVNode("div", _hoisted_72, [
                            _createVNode(_component_PdfChip, {
                              color: "yellow",
                              "mangel-amount-mode": "",
                              value: 
                    Object?.values(_ctx.getSeilzugflaecheBewertungen(_ctx.ba,seilzugflaeche)?.['flaecheZwischenMastUndSeilzug'])
                      ?.flat(1)
                      ?.filter((f) => {
                        return f === 'minus';
                      })?.length
                  ,
                              "pdf-mode": ""
                            }, null, 8, ["value"])
                          ]),
                          _createElementVNode("div", _hoisted_73, [
                            _createVNode(_component_PdfChip, {
                              color: "red",
                              "mangel-amount-mode": "",
                              value: 
                    Object?.values(_ctx.getSeilzugflaecheBewertungen(_ctx.ba,seilzugflaeche)?.['flaecheZwischenMastUndSeilzug'])
                      ?.flat(1)
                      ?.filter((f) => {
                        return f === 'x';
                      })?.length
                  ,
                              "pdf-mode": ""
                            }, null, 8, ["value"])
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_74, "Fläche zwischen Mast und Seilzugfläche nicht vorhanden und nicht benötigt"))
                  ])
                ]))
              }), 128)),
              _hoisted_75,
              _createElementVNode("div", _hoisted_76, [
                _hoisted_77,
                _createElementVNode("div", null, [
                  _createVNode(_component_PdfChip, {
                    color: _ctx.colorFremdleitung,
                    "mangel-amount-mode": "",
                    value: _ctx.amountFremdleitung,
                    "pdf-mode": ""
                  }, null, 8, ["color", "value"])
                ])
              ]),
              _createElementVNode("div", _hoisted_78, [
                _hoisted_79,
                _createElementVNode("div", _hoisted_80, [
                  _createVNode(_component_PdfChip, {
                    color: "green",
                    "mangel-amount-mode": "",
                    value: 
                    Object?.values(_ctx.getFremdleitungenBewertungen(_ctx.ba))
                      ?.flat(1)
                      ?.filter((f) => {
                        return f === 'plus';
                      })?.length
                  ,
                    "pdf-mode": ""
                  }, null, 8, ["value"])
                ]),
                _createElementVNode("div", _hoisted_81, [
                  _createVNode(_component_PdfChip, {
                    color: "blue",
                    "mangel-amount-mode": "",
                    value: 
                    Object?.values(_ctx.getFremdleitungenBewertungen(_ctx.ba))
                      ?.flat(1)
                      ?.filter((f) => {
                        return f === 'o';
                      })?.length
                  ,
                    "pdf-mode": ""
                  }, null, 8, ["value"])
                ]),
                _createElementVNode("div", _hoisted_82, [
                  _createVNode(_component_PdfChip, {
                    color: "yellow",
                    "mangel-amount-mode": "",
                    value: 
                    Object?.values(_ctx.getFremdleitungenBewertungen(_ctx.ba))
                      ?.flat(1)
                      ?.filter((f) => {
                        return f === 'minus';
                      })?.length
                  ,
                    "pdf-mode": ""
                  }, null, 8, ["value"])
                ]),
                _createElementVNode("div", _hoisted_83, [
                  _createVNode(_component_PdfChip, {
                    color: "red",
                    "mangel-amount-mode": "",
                    value: 
                    Object?.values(_ctx.getFremdleitungenBewertungen(_ctx.ba))
                      ?.flat(1)
                      ?.filter((f) => {
                        return f === 'x';
                      })?.length
                  ,
                    "pdf-mode": ""
                  }, null, 8, ["value"])
                ])
              ])
            ])
          ]),
          _createVNode(_component_seilzugflaechen_footer, {
            ba: _ctx.ba,
            immobilie: _ctx.immobilie,
            lang: _ctx.lang,
            class: ""
          }, null, 8, ["ba", "immobilie", "lang"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["pdf-key"]))
}